// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Question: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.4 4.6A14.6 14.6 0 0015 .3C11.1.3 7.4 1.8 4.6 4.6A14.6 14.6 0 00.3 15c0 3.9 1.5 7.6 4.3 10.4 2.8 2.8 6.5 4.3 10.4 4.3s7.6-1.5 10.4-4.3c2.8-2.8 4.3-6.5 4.3-10.4 0-3.9-1.5-7.6-4.3-10.4M24 24c-2.4 2.4-5.6 3.7-9 3.7S8.4 26.4 6 24s-3.7-5.6-3.7-9S3.6 8.4 6 6s5.6-3.7 9-3.7 6.6 1.3 9 3.7c2.4 2.4 3.7 5.6 3.7 9s-1.3 6.6-3.7 9z"/><path d="M14 21.2h.1c.5 0 .9.4.9.9s-.4.9-.9.9H14c-.5 0-.9-.4-.9-.9 0-.4.4-.9.9-.9zm1-13.8c-3 0-4.2 1-4.6 2.2-.2.6.2 1.2.8 1.2h.3c.4 0 .7-.2.8-.6.2-.4.8-.8 2.7-.8 1.7 0 2.8.9 2.8 2.3 0 1-1.5 2.1-2.3 2.4-.1 0-1.4.7-2.1 2.5-.1.3-.2.9-.3 1.5-.1.6.4 1.1 1 1.1.5 0 .9-.4 1-.9.1-.5.1-1 .2-1.2.4-.9 1-1.2 1-1.3.4-.2 3.4-1.8 3.4-4.2.1-2.4-1.9-4.2-4.7-4.2z"/></svg>;
};

export default React.memo(Question);
